'use client';

import styled from 'styled-components';

import type { ListItemElementType, TextAlignType, TextDirectionType } from '@zoomit/editor';
import { cssVar, theme } from '@zoomit/zoomit-ds';

interface RenderElementProps {
  children: any;
  element: ListItemElementType;
  id?: string;
}

const ListItemElement = (props: RenderElementProps) => {
  const { children, element } = props;

  return (
    <ListItem textAlign={element.annotations.textAlign} textDir={element.annotations.textDirection}>
      {children}
    </ListItem>
  );
};

type ListItemProps = {
  textAlign: TextAlignType;
  textDir: TextDirectionType;
};

const ListItem = styled.li<ListItemProps>`
  line-height: 1.88;
  font-size: 1.6rem;
  margin: 0;
  text-align: ${({ textAlign }) => textAlign};
  direction: ${({ textDir }) => textDir};
  color: ${cssVar(theme.text)};
  position: relative;
  padding-right: ${({ textDir }) => (textDir === 'rtl' ? '32px' : 'unset')};
  padding-left: ${({ textDir }) => (textDir === 'ltr' ? '32px' : 'unset')};

  &::before {
    position: absolute;
    ${({ textDir }) => (textDir === 'ltr' ? 'left: 13px' : 'right: 13px')};
    top: 12px;
    content: '';
    width: 6px;
    height: 6px;
    border-radius: var(${theme.radius.full});
    background-color: var(${theme.primary2});
    font-weight: bold;
    display: inline-block;
  }
`;

export default ListItemElement;
